<template>
    <div>
        <van-form ref="form" :model="item" :rules="rules">
            <van-image :src="smallLogo" style="width: 100vw;"/>
            <van-cell title="请填写购房人身份信息" size="large"/>
            <van-cell-group>
                <van-field
                        v-model.trim="item.name"
                        :required="required"
                        clearable
                        label="真实姓名"
                        placeholder="请输入真实姓名"

                />

                <van-field
                        v-model.trim="item.certNo"
                        label="身份证号码"
                        placeholder="请输入身份证号码"
                        :required="required"
                />
            </van-cell-group>
            <van-row type="flex" justify="center">
                <van-col span="22">
                    <van-button type="primary" size="large" @click="verifyOwner">确认</van-button>
                </van-col>
            </van-row>
        </van-form>
    </div>
</template>

<script>

    import {ownerConfirm, depositApply} from '@/api/maintainFund/maintainFund'

    export default {
        name: 'OwnerConfirm',
        data() {
            return {
                smallLogo: require('@/assets/small-logo.png'),
                item: {},
                rules: {
                    name: [
                        {required: true, message: '请输入真实姓名', trigger: 'blur'}
                    ],
                    certNo: [
                        {required: true, message: '请输入身份证号码', trigger: 'blur'}
                    ]
                }
            }
        },
        methods: {
            //核验成功后，吊起e签宝
            verifyOwner() {
                let owner = {
                    houseGuid: this.$route.query.houseNo,
                    ownerName: this.item.name,
                    certNo: this.item.certNo
                };
                ownerConfirm(owner).then(res => {
                    if (res.data !== "") {
                        this.$toast.success('购房人信息认证成功...');
                        let param = {
                            subAccount: res.data,
                            fillOwnerName: this.item.name,
                            fillOwnerCertNo: this.item.certNo,
                            houseNo: this.$route.query.houseNo
                        };
                        debugger
                        depositApply(param).then(res => {
                            this.$router.push({
                                path: '/maintainFund/depositInfo',
                                query: {
                                    label: '交存申请',
                                    payChannels: res.data.payChannels,
                                    houseDepMobiles: res.data.houseDepMobiles
                                }
                            })
                        })
                    } else {
                        this.$dialog.alert({
                            message: '购房人信息认证失败...'
                        }).then(() => {
                            return false;
                        })
                    }
                });
            }
        }
    }
</script>
